import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-undo",
  "use": "icon-undo-usage",
  "viewBox": "0 0 12 13",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 13\" id=\"icon-undo\"><path d=\"M7.286 3.01H2.928l1.714-1.763L3.429 0 .251 3.268A.894.894 0 0 0 0 3.892c0 .233.09.458.251.623L3.43 7.783l1.213-1.247-1.714-1.763h4.358c1.657 0 3 1.381 3 3.085s-1.343 3.085-3 3.085H3.429v1.763h3.857c2.603 0 4.714-2.17 4.714-4.848C12 5.181 9.89 3.01 7.286 3.01Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol